/** @jsx jsx */
import { jsx } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import { Container, Row, Col } from "components/layout"

import useLocales from "hooks/use-locales"

const LogoWall = () => {
  const { locale } = useLocales()
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          extension: { regex: "/(jpg)|(png)|(tif)|(tiff)|(webp)|(jpeg)/" }
          relativeDirectory: { eq: "logos" }
        }
        sort: { fields: [name], order: ASC }
      ) {
        totalCount
        edges {
          node {
            name
            childImageSharp {
              fluid(maxWidth: 300) {
                src
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Container wide>
      <Row sx={{ flexWrap: "wrap" }}>
        {data.allFile.edges.map(image => {
          const { name } = image.node
          let show = true

          if (locale === "fr") {
            show = !name.includes("-en")
          } else {
            show = !name.includes("-fr")
          }

          if (show) {
            return (
              <Col
                key={image.node.childImageSharp.fluid.src}
                sx={{ width: ["50%", "50%", "33.333%"], p: [3, 4, 5] }}
              >
                <Img
                  fluid={image.node.childImageSharp.fluid}
                  sx={{ mb: 3 }}
                  alt=""
                />
              </Col>
            )
          }

          return null
        })}
      </Row>
    </Container>
  )
}

export default LogoWall
